// Các hằng liên quan đến OData
export const ODATA_SERVER_NAME = 'odata:server_name';
export const ODATA_CONTROLLER_NAME = 'odata:controller_name';
